import React, { useState } from "react";
import "./NuTravel.css";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { addtravelnum } from "../../Redux/actions/NumTravel";
import { NavbarJourney } from "../Navbar/NavbarJourney";
import Logo from "../../images/logo.png";
import { Button, Col, Form, Input, Row } from "antd/lib";

export default function Numtravel() {
  const [form] = Form.useForm();

  const [travelno, settravelno] = useState("");
  const [fieldflag, setFieldflag] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const istravelno = useSelector((state) => state.traveldetail.istravelno);

  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };
  const handleInputChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ name: e.target.value });
  };
  const onFinish = (values) => {
    console.log(values);
    console.log(values);
    dispatch(addtravelnum(values));
    history.push("/travelstep");
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <>
      <NavbarJourney />
      <section
        className="bg-light py-4"
        style={{ minHeight: "calc(100vh - 50px)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6 img-0 col-sm-0  p-2 ">
              <div className="m-4">
                <img
                  className="img-fluid"
                  src="./Images/posp-login.png"
                  width={500}
                  alt=""
                />
              </div>
            </div>
            {/* <div className="col-md-6 col-sm-12 p-2"> */}
            <div className="col-md-6 col-sm-12 p-2 d-flex flex-column justify-content-center align-items-center p-4">
              <div className="text-center">
                <img src={Logo} alt="" style={{ maxWidth: "250px" }} />
              </div>
              <h4 className="text-blue text-center">
                Save upto 85%* on Travel Insurance
              </h4>
              <p className="my-3">Stay home & renew in 2 minutes</p>
              <div className="d-flex align-items-center mt-4">
                <img
                  style={{ width: 20 }}
                  src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fflash.png?alt=media&token=c7213ae8-4a09-4a72-9800-e6eb5e59ff75"
                  alt=""
                />
                <small className="me-4 ms-2 text-success fw-bold">
                  Instant Policy
                </small>
                <img
                  style={{ width: 20 }}
                  src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fbank.png?alt=media&token=4cc16690-6e13-4219-a6ff-dd513fe04d1f"
                  alt=""
                />
                <small className="me-4 ms-2 text-warning fw-bold">
                  Best Prices
                </small>
                <img
                  style={{ width: 20 }}
                  src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fdocuments.png?alt=media&token=7923cd01-4150-4801-a4bf-8a42120125c9"
                  alt=""
                />
                <small className="me-4 ms-2 text-info fw-bold">
                  No Paperwork
                </small>
              </div>
              <Form
                // layout={formLayout}
                form={form}
                style={{ width: "72%" }}
                requiredMark={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Row gutter={24}>
                  <Col span={24} style={{ paddingTop: "10px" }}>
                    <Form.Item
                      {...formItemLayout}
                      label="Enter Name"
                      name="name"
                      rules={[
                        {
                          pattern: /^[A-Za-z]+$/,
                          message: "Invalid Name, only letters are allowed",
                        },
                        {
                          required: true,
                          message: "please input name",
                        },
                      ]}
                    >
                      <Input
                        onChange={handleInputChange}
                        placeholder="Enter Name (eg. Harry)"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                {/* <Form.Item
                                {...formItemLayout}
                                    label="Mobile Number"
                                    name='phonenumber'
                                    rules={[
                                        {
                                          pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                                          message: 'Invalid Mobile No',
                                        },
                                        { required: true, message: 'Enter Mobile No' },
                                      ]}
                                >
                                <Input
                                 maxLength={10} 
                                 addonBefore={prefixSelector}
                                />
                                </Form.Item> */}

                <Form.Item {...buttonItemLayout}>
                  <Button
                    style={{ width: "100%" }}
                    type="primary"
                    htmlType="submit"
                  >
                    View Prices
                  </Button>
                </Form.Item>
              </Form>
              {/* <TextField
                                error={fieldflag}
                                className="w-75 my-4"
                                id="standard-error-helper-text"
                                label={fieldflag ? "error" : "Enter Name in 5 letters"}
                                placeholder='Enter Name in 5 letters (eg. Harry)'
                                value={travelno}
                                pattern="[A-Z]{2}[0-9]{1}[A-Z]{2}[0-9]{4}"
                                onChange={(e) => { settravelno(e.target.value.toUpperCase()) }}
                                helperText={fieldflag ? "Incorrect entry." : ""}
                                variant="outlined"
                                required
                            />

                            <Button
                                style={{ background: '#273592' }}
                                className="w-75 mb-5"
                                variant="contained"
                                onClick={() => {
                                    if (travelno != "" && /^[A-Z]{5}$/i.test(travelno)) {
                                        setFieldflag(false)
                                        dispatch(addtravelnum(travelno))

                                    }
                                    else {
                                        setFieldflag(true)
                                    }
                                }}>View Prices</Button> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
